export default __webpack_public_path__ + "static/media/search-icon.ba93b9ac.svg";